export default __webpack_public_path__ + "static/1-d192bece4d136c0073d5a973fa93c1f0e3a5908a50fb21f0304d85f0f8e0c325.png";